module.exports = __webpack_public_path__ + "static/media/icon_female.fc501d04.png";